var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93458 13.9958H21.3947C22.7397 13.9958 23.5822 12.4789 22.7397 11.4652L16.5097 1.18359C16.3516 0.949333 16.1386 0.757477 15.8893 0.624843C15.64 0.492209 15.362 0.422852 15.0796 0.422852C14.7973 0.422852 14.5193 0.492209 14.27 0.624843C14.0206 0.757477 13.8076 0.949333 13.6496 1.18359L7.41956 11.4652C7.26651 11.7254 7.18634 12.0221 7.18751 12.3241C7.18868 12.6261 7.27114 12.9222 7.4262 13.1812C7.58127 13.4402 7.8032 13.6525 8.06865 13.7959C8.33409 13.9393 8.63323 14.0083 8.93458 13.9958Z",
    fill: "#45436B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4247 32.5391C28.6083 32.5391 31.9998 29.1434 31.9998 24.9546C31.9998 20.7658 28.6083 17.3701 24.4247 17.3701C20.2411 17.3701 16.8496 20.7658 16.8496 24.9546C16.8496 29.1434 20.2411 32.5391 24.4247 32.5391Z",
    fill: "#45436B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 18.21H1.685C1.24838 18.2393 0.837156 18.426 0.527388 18.7355C0.217621 19.0449 0.0302739 19.4563 0 19.8934V30.0196C0.0319814 30.4554 0.220083 30.8649 0.529686 31.1728C0.839289 31.4808 1.24956 31.6664 1.685 31.6956H11.7839C12.2211 31.6661 12.6328 31.4789 12.9426 31.1687C13.2525 30.8584 13.4395 30.4462 13.4689 30.0085V19.8934C13.4389 19.458 13.2531 19.0481 12.9457 18.7389C12.6382 18.4297 12.2296 18.2419 11.795 18.21Z",
    fill: "#45436B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.1e81614eba16a795676c7c9b51ff8960.svg";
export { ForwardRef as ReactComponent };